import s from "./SeoText.module.css";
import { BackgroundColorsEnum } from "enums/backgroundColors";

const SeoText = ({ content, appearance }) => {
  const { text: textTop, textLeft, textRight } = content;
  const { frameClass = "0" } = appearance;

  return (
    <div className={`${BackgroundColorsEnum[frameClass || 0]}`}>
      <div
        className={`${s.SeoText} container ${
          frameClass === "7" ? "py-2 lg:py-2 !text-gray-300" : "py-8 lg:py-16"
        }`}
      >
        <div className="grid grid-cols-2 gap-9 gap-y-12">
          <div
            className="col-span-2"
            dangerouslySetInnerHTML={{ __html: textTop }}
          />
          <div
            className="col-span-2 lg:col-span-1"
            dangerouslySetInnerHTML={{ __html: textLeft }}
          />
          <div
            className="col-span-2 lg:col-span-1"
            dangerouslySetInnerHTML={{ __html: textRight }}
          />
        </div>
      </div>
    </div>
  );
};

export default Object.assign(SeoText);
